/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * The names of all the cities supported by the system
 */
export enum CityName {
  ADDISON = "ADDISON",
  ALBUQUERQUE = "ALBUQUERQUE",
  ALEXANDRIA = "ALEXANDRIA",
  ARLINGTON = "ARLINGTON",
  ATLANTA = "ATLANTA",
  AURORA = "AURORA",
  AUSTIN = "AUSTIN",
  BAKERSFIELD = "BAKERSFIELD",
  BALTIMORE = "BALTIMORE",
  BATON_ROUGE = "BATON_ROUGE",
  BELLEVUE = "BELLEVUE",
  BOSTON = "BOSTON",
  CARLSBAD = "CARLSBAD",
  CARROLLTON = "CARROLLTON",
  CHANDLER = "CHANDLER",
  CHARLOTTE = "CHARLOTTE",
  CHESAPEAKE = "CHESAPEAKE",
  CHICAGO = "CHICAGO",
  CINCINNATI = "CINCINNATI",
  COLORADO_SPRINGS = "COLORADO_SPRINGS",
  COLUMBIA = "COLUMBIA",
  COLUMBUS = "COLUMBUS",
  DALLAS = "DALLAS",
  DAYTON = "DAYTON",
  DENVER = "DENVER",
  DETROIT = "DETROIT",
  ELK_GROVE_VILLAGE = "ELK_GROVE_VILLAGE",
  ENGLEWOOD = "ENGLEWOOD",
  FAIRFAX = "FAIRFAX",
  FAIRFIELD_COUNTY = "FAIRFIELD_COUNTY",
  FARMERS_BRANCH = "FARMERS_BRANCH",
  FOLSOM = "FOLSOM",
  FORT_COLLINS = "FORT_COLLINS",
  FORT_LAUDERDALE = "FORT_LAUDERDALE",
  FORT_WAYNE = "FORT_WAYNE",
  FORT_WORTH = "FORT_WORTH",
  FREDERICKSBURG = "FREDERICKSBURG",
  FRESNO = "FRESNO",
  GARLAND = "GARLAND",
  GLEN_ALLEN = "GLEN_ALLEN",
  GRAND_PRAIRIE = "GRAND_PRAIRIE",
  GRAND_RAPIDS = "GRAND_RAPIDS",
  GREENVILLE = "GREENVILLE",
  GREENWICH = "GREENWICH",
  HONOLULU = "HONOLULU",
  HOUSTON = "HOUSTON",
  INDIANAPOLIS = "INDIANAPOLIS",
  IRVINE = "IRVINE",
  IRVING = "IRVING",
  JACKSONVILLE = "JACKSONVILLE",
  KATY = "KATY",
  KNOXVILLE = "KNOXVILLE",
  LANSING = "LANSING",
  LAS_VEGAS = "LAS_VEGAS",
  LOS_ANGELES = "LOS_ANGELES",
  LOUISVILLE = "LOUISVILLE",
  MEMPHIS = "MEMPHIS",
  MESA = "MESA",
  MIAMI = "MIAMI",
  MILWAUKEE = "MILWAUKEE",
  MINNEAPOLIS = "MINNEAPOLIS",
  NAMPA = "NAMPA",
  NASHVILLE = "NASHVILLE",
  NEW_ORLEANS = "NEW_ORLEANS",
  NEW_YORK = "NEW_YORK",
  NORFOLK = "NORFOLK",
  OAKLAND_EAST_BAY = "OAKLAND_EAST_BAY",
  OMAHA = "OMAHA",
  ORANGE_COUNTY = "ORANGE_COUNTY",
  ORLANDO = "ORLANDO",
  PALM_BEACH = "PALM_BEACH",
  PENSACOLA = "PENSACOLA",
  PHILADELPHIA = "PHILADELPHIA",
  PHOENIX = "PHOENIX",
  PITTSBURGH = "PITTSBURGH",
  PLANO = "PLANO",
  PORTLAND = "PORTLAND",
  RALEIGH_DURHAM = "RALEIGH_DURHAM",
  RESTON = "RESTON",
  RICHARDSON = "RICHARDSON",
  RICHMOND = "RICHMOND",
  RIVERSIDE = "RIVERSIDE",
  ROCKVILLE = "ROCKVILLE",
  ROUND_ROCK = "ROUND_ROCK",
  SACRAMENTO = "SACRAMENTO",
  SALT_LAKE_CITY = "SALT_LAKE_CITY",
  SAN_ANTONIO = "SAN_ANTONIO",
  SAN_DIEGO = "SAN_DIEGO",
  SAN_FRANCISCO = "SAN_FRANCISCO",
  SAN_JOSE = "SAN_JOSE",
  SARASOTA = "SARASOTA",
  SCHAUMBURG = "SCHAUMBURG",
  SCOTTSDALE = "SCOTTSDALE",
  SEATTLE = "SEATTLE",
  SILICON_VALLEY = "SILICON_VALLEY",
  SPRING = "SPRING",
  STAMFORD = "STAMFORD",
  STERLING = "STERLING",
  ST_LOUIS = "ST_LOUIS",
  TAMPA = "TAMPA",
  TEMPE = "TEMPE",
  TORONTO = "TORONTO",
  TUCSON = "TUCSON",
  TULSA = "TULSA",
  TYSONS_CORNER = "TYSONS_CORNER",
  VIRGINIA_BEACH = "VIRGINIA_BEACH",
  WASHINGTON = "WASHINGTON",
  WESTCHESTER = "WESTCHESTER",
  WILMINGTON = "WILMINGTON",
}

export enum FeatureFlag {
  BROKER_SUGGESTED_LISTINGS = "BROKER_SUGGESTED_LISTINGS",
  PROPOSAL_GENERATOR = "PROPOSAL_GENERATOR",
  RETICULATING_SPLINES = "RETICULATING_SPLINES",
  SHORTLIST = "SHORTLIST",
}

/**
 * The main floor material used in a space
 */
export enum FloorMaterial {
  CARPET = "CARPET",
  CONCRETE = "CONCRETE",
  HARDWOOD = "HARDWOOD",
  UNKNOWN = "UNKNOWN",
}

/**
 * Visibility of a geoboundable
 */
export enum GeoboundableVisibility {
  HIDDEN = "HIDDEN",
  VETTING = "VETTING",
  VISIBLE = "VISIBLE",
}

export enum ImageAttachedToKind {
  BUILDING = "BUILDING",
  CAMPAIGN_LISTING = "CAMPAIGN_LISTING",
  CAMPAIGN_LISTING_SHARED_NOTE = "CAMPAIGN_LISTING_SHARED_NOTE",
  LISTING = "LISTING",
  LISTING_FLOORPLAN = "LISTING_FLOORPLAN",
}

/**
 * The platform that creates image uploads
 */
export enum ImageSourcePlatform2 {
  IMPORTERS = "IMPORTERS",
  WEB = "WEB",
  iOS = "iOS",
}

/**
 * Image upload states
 */
export enum ImageUploadStatus2 {
  ATTACHING = "ATTACHING",
  AWAITING_UPLOAD = "AWAITING_UPLOAD",
  DUPLICATED = "DUPLICATED",
  FAILED = "FAILED",
  PROCESSING = "PROCESSING",
  PUBLISHED = "PUBLISHED",
  PUBLISHING = "PUBLISHING",
}


/**
 * How long a renter is willing to sign a lease for
 */
export enum LeaseTerm {
  FLEXIBLE = "FLEXIBLE",
  FOUR_TO_SIX_MONTHS = "FOUR_TO_SIX_MONTHS",
  LESS_THAN_ONE_YEAR = "LESS_THAN_ONE_YEAR",
  MORE_THAN_FIVE_YEARS = "MORE_THAN_FIVE_YEARS",
  MORE_THAN_TWELVE_MONTHS = "MORE_THAN_TWELVE_MONTHS",
  ONE_TO_THREE_MONTHS = "ONE_TO_THREE_MONTHS",
  ONE_TO_TWO_YEARS = "ONE_TO_TWO_YEARS",
  SEVEN_TO_TWELVE_MONTHS = "SEVEN_TO_TWELVE_MONTHS",
  THREE_TO_FIVE_YEARS = "THREE_TO_FIVE_YEARS",
}

/**
 * The type of lease a listing represents. These values are an aggregate of numerous boolean fields, with a Direct lease being the default.
 */
export enum LeaseType {
  DIRECT = "DIRECT",
  LICENSE_AGREEMENT = "LICENSE_AGREEMENT",
  SUBLEASE = "SUBLEASE",
  UNKNOWN = "UNKNOWN",
}

/**
 * The confirmation status of a listing in our database
 */
export enum ListingStatus {
  AVAILABLE = "AVAILABLE",
  LEASE_OUT = "LEASE_OUT",
  OFFERS_IN = "OFFERS_IN",
  SF_LEASE_OUT = "SF_LEASE_OUT",
  SF_OFFERS_IN = "SF_OFFERS_IN",
  UNAVAILABLE = "UNAVAILABLE",
  VETTING = "VETTING",
}

/**
 * How much natural light a space receives
 */
export enum NaturalLight {
  EXCELLENT = "EXCELLENT",
  GOOD = "GOOD",
  NONE = "NONE",
  POOR = "POOR",
  VERY_GOOD = "VERY_GOOD",
}

/**
 * The different user task names supported by CompletedUserTask
 */
export enum UserTask {
  request_appointment_engagement_box = "request_appointment_engagement_box",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
